module.exports = {
  'Products for you - HSBC': 'Productos para ti - HSBC',
};
